import { createContext, useContext, useState } from 'react'

const NotificationContext = createContext()

function useNotifications() {
  const context = useContext(NotificationContext)
  if (!context) {
    throw new Error('useNotifications must be used within NotificationProvider')
  }
  return context
}

function useNotification() {
  const context = useNotifications()
  return {
    showNotification: context.addNotification,
    ...context,
  }
}

export { useNotifications, useNotification }

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([])

  const addNotification = (message, type = 'info') => {
    const id = Date.now()
    const notification = { id, message, type, time: new Date() }
    setNotifications((prev) => [...prev.slice(-2), notification])
  }

  const removeNotification = (id) => {
    setNotifications((prev) => prev.filter((n) => n.id !== id))
  }

  const clearAllNotifications = () => {
    setNotifications([])
  }

  const value = {
    notifications,
    addNotification,
    removeNotification,
    clearAllNotifications,
  }

  return (
    <NotificationContext.Provider value={value}>
      {children}
    </NotificationContext.Provider>
  )
}
